import { getFolderShareInvite } from '@jotta/grpc-connect-openapi/inviteQuery'
import { createConnectQuery } from '../createConnectQuery'

export const useFolderInviteQuery = createConnectQuery(getFolderShareInvite)

export function useFolderInvite(folderShareInviteId: string) {
  return useFolderInviteQuery({
    variables: { folderShareInviteId },
    enabled: Boolean(folderShareInviteId),
  })
}
